import api from './api';

// Obtener todos los proveedores
export const getAllVendors = async () => {
  try {
    const response = await api.get('/vendors');
    return response.data;
  } catch (error) {
    console.error('Error al obtener proveedores:', error);
    throw error;
  }
};

// Obtener un proveedor por ID
export const getVendorById = async (id) => {
  try {
    const response = await api.get(`/vendors/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener proveedor:', error);
    throw error;
  }
};

// Crear un nuevo proveedor
export const createVendor = async (data) => {
  try {
    const response = await api.post('/vendors', data);
    return response.data;
  } catch (error) {
    console.error('Error al crear proveedor:', error);
    throw error;
  }
};

// Actualizar un proveedor
export const updateVendor = async (id, data) => {
  try {
    const response = await api.put(`/vendors/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar proveedor:', error);
    throw error;
  }
};

// Eliminar un proveedor
export const deleteVendor = async (id) => {
  try {
    const response = await api.delete(`/vendors/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar proveedor:', error);
    throw error;
  }
};